module.exports = __webpack_public_path__ + "assets/img/cf42-tc.svg";